import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setErrors } from "../../store/alerts/alertsActions";
import tryCatchRequest from "../../api/tryCatchRequest";

const useRequest = <T>(request: Function, onSuccess = (result: T) => {}): [T | null, boolean, Function, Function] => {
  const dispatch = useDispatch();
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const controller = new AbortController();
    const requestFunc = async () => {
      await tryCatchRequest(
        () => request(controller.signal),
        (result: any) => {
          setData(result);
          onSuccess(result);
        },
        dispatch,
        () => setLoading(false)
      );
    };
    requestFunc();
    return () => controller.abort();
    //eslint-disable-next-line
  }, []);

  return [data, loading, setLoading, setErrors];
};

export default useRequest;
